import React from 'react';
import PropTypes from 'prop-types';
import ItemDialog from './ItemDialog';
import OverlayController from '../overlay/OverlayController';
import mustache from 'mustache';


export default class Item extends React.Component {

    static propTypes = {
        projectId: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        queueItemViewButtons: PropTypes.array.isRequired,
        listViewTemplate: PropTypes.object.isRequired
    };

    static defaultProps = {

    };

    onItemClick() {
        let options = {
            component: (
                <ItemDialog
                    projectId={this.props.projectId}
                    itemId={this.props.item.id}
                    queueItemViewButtons={this.props.queueItemViewButtons}
                />
            ),
            className: 'itemDialogOverlayContent'
        };
        OverlayController.showOverlay(options);
    }

    listViewHTML() {
        let createdAtDate = new Date(this.props.item.createdAt);
        let updatedAtDate = new Date(this.props.item.updatedAt);

        // Replace dates with human readable format
        let data = Object.assign({}, this.props.item, {
            createdAt: createdAtDate.toLocaleString(),
            updatedAt: updatedAtDate.toLocaleString()
        });

        return mustache.render(this.props.listViewTemplate.template, data);
    }

    render() {
        return (
            <div className="itemListItem"
                 dangerouslySetInnerHTML={{__html: this.listViewHTML()}}
                 onClick={this.onItemClick.bind(this)}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/item/Item.js